module.exports = __webpack_public_path__ + "media/honey-icons/icon-check2-4a9698ad.svg";